export default {"src":"/_next/static/media/skip_kyc.b60e5847.svg","height":222,"width":301,"blurWidth":0,"blurHeight":0};